<script setup lang="ts">
/**
 * The gold coin.
 *
 * Was a hand-drawn SVG while the art pack had no coin; now it is the painted
 * one. Kept as a component rather than a bare <img> so every appearance, from
 * a 14px inline glyph to a treasury heading, sizes the same way and a future
 * swap is one file again.
 */
import { GAME_ICONS } from '@/assets/art/art';

withDefaults(defineProps<{ size?: number }>(), { size: 18 });
</script>

<template>
  <img
    class="coin"
    :src="GAME_ICONS.gold"
    :width="size"
    :height="size"
    alt=""
    aria-hidden="true"
    draggable="false"
  />
</template>

<style scoped>
.coin {
  display: inline-block;
  flex: none;
  vertical-align: -0.15em;
  object-fit: contain;
}
</style>
